import React from 'react';
import { useGlobalAddressContext } from '../../AddressInfo';
import './Styles.css';
import { changeAddressForAgent, inheritAddressFromTeam } from '../../CommonFunctions';
import { formatMessage } from '../../../../../../../Localization/formatMessage';
import Messages from '../../../../../../../Localization/Messages';
import { PresentationMode } from '../../../../../../../Enums/PresentationMode';
import { useTeamPageContext } from '../../../../../TeamPage';
import SecondaryButton from '../../../../../../../Elements/ids/Buttons/SecondaryButton';
import PrimaryButton from '../../../../../../../Elements/ids/Buttons/PrimaryButton';

const Warning = () => {
  const { agentCode, codePrefix, addressState, addressDispatch, setModalMode } = useGlobalAddressContext();

  const { teamPageDispatch } = useTeamPageContext();

  return (
    <>
      <p className="team-page_address-info_warning-paragraph">
        {formatMessage(Messages.addressInfo_warning)}
        <br />
        {formatMessage(Messages.addressInfo_warningQuestion)}
      </p>
      <div className="team-page_address-info_warning-buttons">
        <SecondaryButton
          text={formatMessage(Messages.addressInfo_warningInherit)}
          onClickEvent={() => {
            inheritAddressFromTeam(agentCode, codePrefix, addressDispatch, teamPageDispatch);
            setModalMode(PresentationMode.View);
          }}
          isSmall={true}
        />

        <PrimaryButton
          text={formatMessage(Messages.addressInfo_warningContinue)}
          onClickEvent={() => {
            changeAddressForAgent(agentCode, codePrefix, addressState.address.id, addressDispatch, teamPageDispatch);
            setModalMode(PresentationMode.View);
          }}
          isSmall={true}
        />
      </div>
    </>
  );
};

export default Warning;
